import {getScope} from './state';

const messageParent = (message) => {
    const affiliate = getScope().custom && getScope().custom.origin;
    affiliate && top.postMessage(message, affiliate);
};

export {messageParent};